import { useState } from "react";

import { TelkomIdCreds } from "../constants/constants";
import { useNavigate } from "react-router-dom";

export const useTelkomIdLogin = () => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    nik: "",
    nikStatus: "normal",
    nikErrorMessage: "",
    password: "",
    passwordStatus: "normal",
    passwordErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleLogin = () => {
    if (!state.nik || state.nik.length < 8 || state.nik.length > 10) {
      setState({
        ...state,
        nikStatus: "error",
        nikErrorMessage: "NIK must consist of 8-10 digit",
      });

      return;
    }

    if (
      !state.password ||
      state.password.length < 8 ||
      state.password.length > 16
    ) {
      setState({
        ...state,
        nikStatus: "normal",
        nikErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage: "Password must consist of 8-16 digit",
      });

      return;
    }

    setState({
      ...state,
      nikStatus: "normal",
      nikErrorMessage: "",
      passwordStatus: "normal",
      passwordErrorMessage: "",
    });

    try {

      if (parseInt(state.nik) !== TelkomIdCreds.nik) {
        setState({
          ...state,
          nikStatus: "error",
          nikErrorMessage: "NIK not registered",
        });

        return;
      }

      if (state.password.trim() !== TelkomIdCreds.password) {
        setState({
          ...state,
          passwordStatus: "error",
          passwordErrorMessage: "Your password is incorrect, please check and try again",
        });

        return;
      }

      navigate("/dashboard")
    } catch (e) {
      console.log(e);
    }
  };

  return {
    state,
    handleForms,
    handleLogin,
  };
};
